(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sc-cart-addons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sc-cart-addons')) {
class SCCartAddons extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    const localePath = window.location.pathname.match(new RegExp('^/([a-z]{2}(?:-[a-z]{2})?)(?:/|$)', 'i'));
    if (localePath && document.documentElement.lang.toLowerCase().startsWith(localePath[1].toLowerCase())) {
      this.dataset.root = '/' + localePath[1] + '/';
      this.dataset.cartUrl = this.dataset.root + 'cart';
    }
    this.copy = JSON.parse(this.querySelector('[data-sc-copy]').textContent)[document.documentElement.lang.split('-')[0]] || null;
    if (this.copy) { this.dataset.title = this.copy.title; this.dataset.error = this.copy.error; this.dataset.busy = this.copy.busy; }
    this.translate(this);
    this.dialog = this.querySelector('dialog');
    this.modalOffers = this.querySelector('[data-sc-modal-offers]');
    this.message = this.querySelector('[data-sc-message]');
    this.busy = false;
    this.pending = null;
    this.sequence = 0;
    this.refresh = this.refresh.bind(this);
    document.addEventListener('click', event => {
      const install = event.target.closest('[data-sc-install]');
      if (install) { event.preventDefault(); this.install(install); return; }
      const upgrade = event.target.closest('[data-sc-upgrade]');
      if (upgrade) { event.preventDefault(); this.upgrade(upgrade); return; }
      if (event.target.closest('[data-sc-close]') && this.contains(event.target)) {
        if (!this.busy) { this.dialog.close(); this.pending = null; }
      }
      if (event.target.closest('[data-sc-continue]') && this.contains(event.target)) this.continueCheckout();
    });
    document.addEventListener('change', event => {
      if (!event.target.matches('[data-sc-upgrade-choice]')) return;
      const button = event.target.closest('[data-sc-offer]').querySelector('[data-sc-upgrade]');
      button.dataset.variant = event.target.value;
      button.disabled = !event.target.value;
    });
    document.addEventListener('submit', event => {
      if (this.bypass || !event.submitter || event.submitter.name !== 'checkout') return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.busy) return;
      this.openReminder(event.target, event.submitter);
    }, true);
    this.dialog.addEventListener('cancel', event => { if (this.busy) event.preventDefault(); else this.pending = null; });
    this.observer = new MutationObserver(records => {
      if (records.every(record => this.contains(record.target) || record.target.closest?.('[data-sc-cart-addons-slot]'))) return;
      clearTimeout(this.timer);
      this.timer = setTimeout(this.refresh, 250);
    });
    this.observer.observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['open','aria-hidden']});
    this.refresh();
    window.addEventListener('pageshow', this.refresh);
  }
  translate(root) {
    const language = document.documentElement.lang || 'sv';
    this.copy = JSON.parse(this.querySelector('[data-sc-copy]').textContent)[language.split('-')[0]] || this.copy;
    if (!this.copy) return;
    const currency = root.dataset?.currency || this.dataset.currency;
    const formatMoney = cents => {
      try { return new Intl.NumberFormat(language, {style:'currency',currency:currency}).format(Number(cents) / 100); }
      catch (_) { return null; }
    };
    root.querySelectorAll('[data-sc-money]').forEach(element => {
      const formatted = formatMoney(element.dataset.scMoney);
      if (formatted) element.textContent = '+' + formatted;
    });
    root.querySelectorAll('option[data-cents]').forEach(element => {
      const formatted = formatMoney(element.dataset.cents);
      if (formatted) element.dataset.price = ' (+' + formatted + ')';
    });
    root.querySelectorAll('[data-sc-i18n]').forEach(element => {
      const value = this.copy[element.dataset.scI18n];
      if (value) element.textContent = value.replace('__QUANTITY__', element.dataset.quantity || '') + (element.dataset.price || '');
    });
    root.querySelectorAll('[data-sc-close][aria-label]').forEach(element => element.setAttribute('aria-label', this.copy.close));
  }
  async offers() {
    const response = await fetch(this.dataset.root + '?section_id=sc-cart-addons', {credentials:'same-origin',cache:'no-store'});
    if (!response.ok) throw new Error('offers');
    const document = new DOMParser().parseFromString(await response.text(), 'text/html');
    const source = document.querySelector('[data-sc-addon-source]');
    if (!source) throw new Error('offers');
    this.dataset.currency = source.dataset.currency;
    this.translate(source);
    return source;
  }
  paint(source) {
    document.querySelectorAll('[data-sc-cart-addons-slot]').forEach(slot => {
      slot.replaceChildren();
      if (!source.querySelector('[data-sc-offer]')) return;
      const panel = document.createElement('section');
      panel.className = 'sc-cart-addon-panel';
      panel.dir = document.documentElement.lang.startsWith('ar') ? 'rtl' : 'ltr';
      const title = document.createElement('h2'); title.textContent = this.dataset.title;
      panel.append(title, ...Array.from(source.cloneNode(true).children));
      const status = document.createElement('p'); status.setAttribute('data-sc-message',''); status.setAttribute('role','status');
      panel.append(status); slot.append(panel);
    });
  }
  async refresh() {
    if (this.busy || this.dialog.open || !document.querySelector('[data-sc-cart-addons-slot]')) return;
    const sequence = ++this.sequence;
    try { const source = await this.offers(); if (sequence === this.sequence && !this.busy) this.paint(source); } catch (_) {}
  }
  async openReminder(form, submitter) {
    this.pending = {form,submitter};
    this.message.textContent = '';
    this.busy = true;
    try {
      const source = await this.offers();
      this.busy = false;
      if (!source.querySelector('[data-sc-offer]')) { this.continueCheckout(); return; }
      const continueLabel = this.querySelector('[data-sc-continue] [data-sc-i18n]');
      continueLabel.dataset.scI18n = source.querySelector('[data-sc-no-heater]') ? 'continue_without_heater' : 'continue';
      this.translate(this);
      this.modalOffers.replaceChildren(...Array.from(source.children));
      this.dialog.dir = document.documentElement.lang.startsWith('ar') ? 'rtl' : 'ltr';
      this.dialog.showModal();
    } catch (_) { this.busy = false; this.continueCheckout(); }
  }
  continueCheckout() {
    if (this.busy || !this.pending) return;
    const {form,submitter} = this.pending;
    this.pending = null;
    this.dialog.close();
    this.bypass = true;
    try { form.requestSubmit(submitter); } finally { this.bypass = false; }
  }
  async api(path, body) {
    const response = await fetch(this.dataset.root + path, {method: body ? 'POST' : 'GET', credentials:'same-origin',headers:{'Content-Type':'application/json'}, ...(body ? {body:JSON.stringify(body)} : {})});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || 'cart');
    return data;
  }
  async install(button) {
    if (this.busy) return;
    this.busy = true;
    const status = button.closest('.sc-cart-addon-panel')?.querySelector('[data-sc-message]') || this.message;
    status.textContent = this.dataset.busy;
    const controls = Array.from(document.querySelectorAll('[data-sc-install], [data-sc-upgrade], [name="checkout"], [data-sc-continue], [data-sc-close]'));
    const disabled = controls.map(control => control.disabled);
    controls.forEach(control => control.disabled = true);
    try {
      const source = await this.offers();
      const current = Array.from(source.querySelectorAll('[data-sc-install]')).find(offer => offer.dataset.model === button.dataset.model);
      if (current) {
        await this.api('cart/add.js', {items:[{id:Number(current.dataset.variant),quantity:Number(current.dataset.quantity),properties:{'_sc_model_id':current.dataset.model,'Bastumodell':current.dataset.modelTitle}}]});
      }
      window.location.assign(this.dataset.cartUrl);
    } catch (_) {
      status.textContent = this.dataset.error;
      this.busy = false;
      controls.forEach((control,index) => control.disabled = disabled[index]);
    }
  }
  async upgrade(button) {
    if (this.busy || !button.dataset.variant) return;
    this.busy = true;
    const status = button.closest('.sc-cart-addon-panel')?.querySelector('[data-sc-message]') || this.message;
    status.textContent = this.dataset.busy;
    const controls = Array.from(document.querySelectorAll('[data-sc-install], [data-sc-upgrade], [name="checkout"], [data-sc-continue], [data-sc-close]'));
    const disabled = controls.map(control => control.disabled);
    controls.forEach(control => control.disabled = true);
    let added = null;
    let item = null;
    try {
      const cart = await this.api('cart.js');
      item = cart.items.find(line => line.key === button.dataset.line);
      if (!item || item.quantity !== Number(button.dataset.quantity)) throw new Error('changed');
      const newItem = {id:Number(button.dataset.variant),quantity:item.quantity,properties:item.properties || {}};
      if (item.selling_plan_allocation) newItem.selling_plan = item.selling_plan_allocation.selling_plan.id;
      const result = await this.api('cart/add.js', {items:[newItem]});
      added = result.items[0];
      try { await this.api('cart/change.js', {id:item.key,quantity:0}); }
      catch (error) {
        const latest = await this.api('cart.js');
        const replacement = latest.items.find(line => line.key === added.key);
        if (replacement) await this.api('cart/change.js', {id:replacement.key,quantity:Math.max(0,replacement.quantity-item.quantity)});
        throw error;
      }
      const note = document.querySelector('[name="note"]');
      if (note && note.value !== cart.note) await this.api('cart/update.js',{note:note.value});
      window.location.assign(this.dataset.cartUrl);
    } catch (_) {
      status.textContent = this.dataset.error;
      this.busy = false;
      controls.forEach((control,index) => control.disabled = disabled[index]);
    }
  }
}
customElements.define('sc-cart-addons', SCCartAddons);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sc-sauna-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sc-sauna-options')) {
    class SCSaunaOptions extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        const init = () => {
          const form = this.closest('form');
          if (!form) return;
          const native = form.querySelector('[data-variant]');
          const controls = [...this.querySelectorAll('[data-sc-option]')];
          if (!native) { if (!controls.length) { this.hidden = false; this.dataset.ready = '1'; } return; }
          const choices = [...native.options].map(option => ({ element: option, id: option.value, cents: Number(option.dataset.priceCents), values: [0,1,2].map(index => option.hasAttribute(`data-option-${index}`) ? Number(option.getAttribute(`data-option-${index}`)) : null) }));
          const initial = choices.find(choice => choice.id === native.value);
          if (!initial || !choices.length || choices.some(choice => !Number.isFinite(choice.cents)) || controls.some(control => choices.some(choice => choice.values[Number(control.dataset.scOption)] === null))) return;
          const selected = [...initial.values];
          controls.forEach(control => { const value = selected[Number(control.dataset.scOption)]; if (control.type === 'checkbox') control.checked = value === Number(control.dataset.on); else control.value = String(value); });
          const match = values => choices.find(choice => choice.values.every((value, index) => value === values[index]));
          const formatter = new Intl.NumberFormat(this.dataset.locale || 'sv', { style: 'currency', currency: this.dataset.currency || 'SEK', maximumFractionDigits: 2 });
          const surcharge = cents => cents > 0 ? ` (+${formatter.format(cents / 100)})` : '';
          const unavailable = this.querySelector('[data-sc-unavailable]');
          const buy = form.querySelector('button[type="submit"]');
          const sync = () => {
            controls.forEach(control => { selected[Number(control.dataset.scOption)] = control.type === 'checkbox' ? Number(control.checked ? control.dataset.on : control.dataset.off) : Number(control.value); });
            const choice = match(selected);
            if (!choice) { buy.disabled = true; unavailable.hidden = false; return; }
            native.value = choice.id;
            native.dispatchEvent(new Event('change', { bubbles: true }));
            unavailable.hidden = choice.element.dataset.available === 'true';
            controls.forEach(control => {
              const index = Number(control.dataset.scOption);
              const baseValues = [...selected]; baseValues[index] = 0;
              const baseline = match(baseValues);
              if (control.type === 'checkbox') {
                const addedValues = [...selected]; addedValues[index] = Number(control.dataset.on);
                const added = match(addedValues);
                control.disabled = !control.checked && (!added || added.element.dataset.available !== 'true');
                const price = control.closest('label').querySelector('[data-addon-price]');
                price.textContent = added && baseline ? surcharge(added.cents - baseline.cents).trim() : this.dataset.unavailable;
              } else {
                [...control.options].forEach(option => {
                  const values = [...selected]; values[index] = Number(option.value);
                  const candidate = match(values);
                  option.disabled = !candidate || candidate.element.dataset.available !== 'true';
                  option.textContent = option.dataset.label + (candidate && baseline ? surcharge(candidate.cents - baseline.cents) : '') + (!candidate || candidate.element.dataset.available !== 'true' ? ` · ${this.dataset.unavailable}` : '');
                });
              }
            });
            const heater = this.querySelector('[data-sc-heater]');
            const hint = this.querySelector('[data-heater-hint]');
            if (heater && hint) hint.textContent = heater.value === '0' ? hint.dataset.without : hint.dataset.with;
          };
          controls.forEach(control => control.addEventListener('change', sync));
          form.addEventListener('submit', event => { const choice = match(selected); if (!choice || choice.element.dataset.available !== 'true') { event.preventDefault(); unavailable.hidden = false; } });
          sync();
          this.dataset.ready = '1';
          this.hidden = false;
          const fallback = form.querySelector('[data-native-variant]');
          if (fallback) fallback.hidden = true;
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
      }
    }
    customElements.define('sc-sauna-options', SCSaunaOptions);
  }
  } catch(e) { console.error(e); }
})();

})();
